<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="海报审核"></pt-page-title>
    <el-tabs v-model="currentStatusFilter" @tab-click="handleClick" slot="title">
      <el-tab-pane label="待审核" name="SUBMITTED"></el-tab-pane>
      <el-tab-pane label="已发布" name="APPROVED"></el-tab-pane>
      <el-tab-pane label="已下架" name="PUBLISHEDFALSE"></el-tab-pane>
    </el-tabs>
    <!-- 表格 -->
    <pt-poster-review-table :tableLabels="currentTableLabels" :status="currentStatusFilter" ref="table">
        <el-table-column label="操作" fixed="right" min-width="200">
            <template slot-scope="scope">
              <template v-if="currentStatusFilter==='SUBMITTED'">
                <el-button type="text" @click="confirm(scope.row,'审核发布',{'status':'APPROVED'})">审核发布</el-button>
                <el-button type="text" @click="confirm(scope.row,'驳回',{'status':'DECLINED'})">驳回</el-button>
              </template>
              <el-button v-if="currentStatusFilter==='APPROVED'" type="text" @click="confirm(scope.row,'下架',{'published':false})">下架</el-button>
              <el-button type="text" @click="preview(scope.row)">预览</el-button>
              <el-button type="text" @click="toDetail(scope.row.id)">详情</el-button>
            </template>
        </el-table-column>
    </pt-poster-review-table>
    <review-poster-mobile :showDialog="showDialog" @closeDialog="showDialog = false" :detail="currentPoster"></review-poster-mobile>
  </div>
</template>

<script>
import { tableLabels, tableLabelsOk } from './poster-review-options'
import ptPosterReviewTable from './pt-poster-review-table/withData'
import reviewPosterMobile from '../review-poster-mobile/index'
// 组件class前缀
const prefixCls = 'pt-poster-review'

export default {
  name: 'pt-poster-review',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      if (this.currentStatusFilter === 'SUBMITTED') {
        return tableLabels
      }
      return tableLabelsOk
    }
  },
  components: { ptPosterReviewTable, reviewPosterMobile },
  data () {
    return {
      showDialog: false,
      loading: false,
      filterForm: {},
      currentStatusFilter: this.$route.params.status,
      currentPoster: {}
    }
  },
  methods: {
    handleClick (tab) {
      this.handleFilter()
      this.$router.push({ name: 'poster-review', params: { status: tab.name } })
    },
    handleFilter () {
      this.filterForm = {
        pageable: { page: 0, size: 20 }
      }
      if (this.currentStatusFilter === 'PUBLISHEDFALSE') {
        this.filterForm.example = {
          published: false,
          status: 'APPROVED'
        }
      } else if (this.currentStatusFilter === 'APPROVED') {
        this.filterForm.example = {
          published: true
        }
      } else {
        this.filterForm.example = {
          status: this.currentStatusFilter
        }
      }
      this.$refs.table.reload(this.filterForm)
    },
    // 审核发布、驳回、下架
    confirm (row, tip, data) {
      this.$confirm(`确定要提交${tip}海报：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        data.id = row.id
        this.$store.dispatch('posterOperation', data).then(data => {
          this.$refs.table.reload()
          this.$message.success('操作成功！')
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      })
    },
    toDetail (id) {
      this.$router.push(`/poster-detail/${id}`)
    },
    // 预览
    preview (data) {
      this.showDialog = true
      this.currentPoster = data
    }
  }

}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-poster-review {
  .el-tabs {
    display: inline-block;
  }
  .el-tabs--top .el-tabs__nav {
    padding-left: 30px;
    padding-right: 30px;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-tabs__active-bar {
    left: 30px;
  }
  .el-button--mini {
    margin-bottom: 10px;
  }
}
</style>
